import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import { Field, Form, Formik } from "formik"
import PropTypes from "prop-types"
import { useContext, useState } from "react"
import { useMutation, useQueryClient } from "react-query"
import { useHistory } from "react-router-dom"
import { createClientApiKey } from "~/actions/clients.js"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AppContext from "~/contexts/App"
import useOpenErrorSnackbar from "~/hooks/useOpenErrorSnackbar"
import serialize from "~/store/serialize"

import Box from "~/components/Common/Box"
import useStyles from "./styles"
const AddKeysToClientsDialog = () => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const queryClient = useQueryClient()

  const { dialogs, closeDialog, openSnackBar } = useContext(AppContext)
  const thisDialog = dialogs?.["AddKeysToClientsDialog"] || {}
  const { open = false, data } = thisDialog
  const openErrorSnackbar = useOpenErrorSnackbar()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  const [loading, setLoading] = useState(false)

  //close dialog set search value to empty string and
  //set component array state to the context state
  const handleClose = () => {
    closeDialog("AddKeysToClientsDialog", false)
  }

  // //close the dialog
  const addCourse = () => {
    setLoading(false)
    handleClose()
  }
  const updateClientMutation = useMutation((data) =>
    createClientApiKey(data.clientId, data.values),
  )

  //set client keys
  const setAddClientKeys = (clientId, values, actions) => {
    setLoading(true)
    let data = {
      clientId: clientId,
      values: values,
    }

    updateClientMutation.mutate(data, {
      onSuccess: (res) => {
        serialize("client", res.client).then((serializedData) => {
          return queryClient.setQueryData("clients", (oldData) => {
            let newArray = []
            newArray = oldData.map((x) => {
              if (x.id !== serializedData[0].id) {
                return x
              } else {
                return serializedData[0]
              }
            })
            return newArray
          })
        })
      },
      onError: (err) => {
        openErrorSnackbar(err, "Error Updating Client Keys")
      },
      onSettled: () => {
        actions.setSubmitting(false)
        handleClose()
      },
    })
  }

  return (
    <Dialog
      classes={{ paperWidthSm: classes.dialogContainer }}
      open={open}
      fullScreen={smDown}
    >
      <DialogTitle className={classes.dialogTitle}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          className={classes.dialogTop}
        >
          <Typography variant="h2" className={classes.title}>
            Create API Token
          </Typography>
        </Box>
      </DialogTitle>
      <Formik
        initialValues={{ name: "", description: "" }}
        onSubmit={(values, actions) => {
          setAddClientKeys(values, data.client.id, actions)
        }}
      >
        <div className={classes.dialogWrapper}>
          <Form className={classes.dialogContent}>
            <Field
              name="name"
              validate={(value) => (value ? null : "Name is required")}
            >
              {({
                field, // { name, value, onChange, onBlur }
                form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                meta,
              }) => (
                <div className={classes.inputWrapper}>
                  <input
                    className={classes.inputBoxes}
                    type="text"
                    placeholder="Name*"
                    {...field}
                  />
                  {meta.touched && meta.error && (
                    <div className={classes.requiredText}>{meta.error}</div>
                  )}
                </div>
              )}
            </Field>
            <Field name="description">
              {({
                field, // { name, value, onChange, onBlur }
                form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                meta,
              }) => (
                <div className={classes.inputWrapper}>
                  <input
                    className={classes.inputBoxes}
                    type="text"
                    placeholder="Description"
                    {...field}
                  />
                  {meta.touched && meta.error && (
                    <div className="error">{meta.error}</div>
                  )}
                </div>
              )}
            </Field>
            <DialogActions
              style={{
                width: "100%",
              }}
              className={classes.actions}
            >
              <Box
                display="flex"
                justifyContent="flex-end"
                width="100%"
                marginLeft="20px"
                marginRight="20px"
                className={classes.actionBox}
              >
                <Box>
                  <Button
                    onClick={handleClose}
                    style={{ height: "40px", marginRight: "10px" }}
                  >
                    Cancel
                  </Button>
                  <LoaderButton
                    working={loading}
                    classoverrides={{
                      wrapper: classes.button,
                      button: {
                        root: classes.buttonRoot,
                      },
                    }}
                    variant="contained"
                    color="secondary"
                    size="small"
                  >
                    Generate Token
                  </LoaderButton>
                </Box>
              </Box>
            </DialogActions>
          </Form>
        </div>
      </Formik>
    </Dialog>
  )
}

AddKeysToClientsDialog.propTypes = {
  id: PropTypes.func,
}
export default AddKeysToClientsDialog
